/** SVG daily request bars — shared by platform + owner usage panels. */
export function TrafficDailyBars({
  byDay,
  emptyLabel = "No daily traffic yet.",
}: {
  byDay: { date: string; requests: number }[];
  emptyLabel?: string;
}) {
  const days = byDay.slice(-14);
  const max = Math.max(1, ...days.map((d) => d.requests));
  const w = 280;
  const h = 72;
  const gap = 2;
  const barW = days.length > 0 ? (w - gap * (days.length - 1)) / days.length : 0;

  if (days.length === 0) {
    return <p className="muted">{emptyLabel}</p>;
  }

  return (
    <svg
      className="platform-traffic-bars"
      viewBox={`0 0 ${w} ${h}`}
      width="100%"
      height={h}
      role="img"
      aria-label="API requests by day"
    >
      {days.map((d, i) => {
        const bh = (d.requests / max) * (h - 4);
        const x = i * (barW + gap);
        const y = h - bh;
        return (
          <rect
            key={d.date}
            x={x}
            y={y}
            width={Math.max(1, barW)}
            height={Math.max(d.requests > 0 ? 2 : 0, bh)}
            rx={1}
            className="platform-traffic-bar"
          >
            <title>
              {d.date}: {d.requests} requests
            </title>
          </rect>
        );
      })}
    </svg>
  );
}
